import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { authStore } from '@/store/authStore';
import { deviceStore } from '@/store/deviceStore';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    namespaced: true,
    authStore,
    deviceStore,
  },
  plugins: [
    createPersistedState({
      paths: ['authStore', 'deviceStore'],
    }),
  ],
});
